/**
 *  @class
 *  @function ProductBundle
 */
if (!customElements.get("product-bundle")) {
  class ProductBundle extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.variantId = this.dataset.variantId;
      this.collectionId = this.dataset.collectionId;
      this.totalSelection = 0;
      this.currentSelection = 0;
      this.productRemoveButtons = [];
      this.bundle = {
        externalProductId: this.productId,
        externalVariantId: this.variantId,
        selections: [],
      };

      this.sizeChange = this.sizeChange.bind(this);
      // this.handleScroll = this.handleScroll.bind(this);
      this.addBundleToCart = this.addBundleToCart.bind(this);

      this.translations = {
        select: window.bundle_translations.select,
        option: window.bundle_translations.option,
        options: window.bundle_translations.options,
        0: window.bundle_translations.one,
        1: window.bundle_translations.two,
        2: window.bundle_translations.three,
        add_to_cart: window.bundle_translations.add_to_cart,
      };
    }

    async connectedCallback() {
      const bundleSettings = await window.recharge.cdn.getCDNBundleSettings(
        this.productId
      );
      this.totalSelection = bundleSettings?.variants[0]?.items_count;
      // Bag Button
      this.bagButton = this.querySelector(".single-add-to-cart-button");
      this.bagButtonText = this.bagButton.querySelector(
        ".single-add-to-cart-button--text"
      );
      // Product Card Buttons
      this.productAddToPackButtons = this.querySelectorAll(
        ".product-card--add-to-pack-button:not(:disabled)"
      );
      // Quantity Input elements
      this.productQuantityInputs = this.querySelectorAll(
        ".quantity.bundle input"
      );
      this.productDecreaseQtyButtons = this.querySelectorAll(
        ".quantity.bundle .minus"
      );
      this.productIncreaseQtyButtons = this.querySelectorAll(
        ".quantity.bundle .plus"
      );

      // Methods
      this.setupSelectionBoxes(this.totalSelection);
      this.setupAddToPackAction();
      this.setupQuantityActions();
      this.setupRemoveAction();
      this.updateBagButton();

      this.bagButton.addEventListener("click", this.addBundleToCart);

      // Window Resize
      const sizeMq = window.matchMedia("(min-width: 1068px)");

      sizeMq.addEventListener("change", this.sizeChange);
      this.sizeChange(sizeMq);
    }

    sizeChange(event) {
      const summaryTop = this.querySelector(".product-bundle__summary-top");
      const summary = this.querySelector(".product-bundle__summary");
      const mainSummary = this.querySelector(".product-bundle__summary-mobile");

      if (!event.matches) {
        mainSummary.appendChild(summaryTop);
        // window.addEventListener("scroll", this.handleScroll);
      } else {
        summary.prepend(summaryTop);
        // window.removeEventListener("scroll", this.handleScroll);
      }
    }

    handleScroll() {
      const targetElement = this.querySelector(".product-bundle__selections");
      const className = "scrolled-past";
      const targetPosition = targetElement.offsetTop;
      const scrollPosition = window.scrollY;

      if (scrollPosition > targetPosition) {
        targetElement.classList.add(className);
      } else {
        targetElement.classList.remove(className);
      }
    }

    updateBagButton() {
      const remainingSelection = this.totalSelection - this.currentSelection;

      if (remainingSelection === 0) {
        this.bagButtonText.textContent = this.translations.add_to_cart;
        this.bagButton.removeAttribute("disabled");
      } else {
        this.bagButtonText.textContent = `${this.translations.select} ${remainingSelection} ${remainingSelection === 1 ? this.translations.option : this.translations.options}`;
        this.bagButton.setAttribute("disabled", "true");
      }
    }

    setupSelectionBoxes(totalSelection) {
      const selectionBox = this.querySelector(".product-bundle__selection");

      if (!selectionBox || !totalSelection) {
        return;
      }

      const parentContainer = selectionBox.parentElement;

      Array.from({ length: totalSelection - 1 }).forEach((_, index) => {
        const clonedBox = selectionBox.cloneNode(true);
        const idx = index + 1;
        clonedBox.setAttribute("data-index", idx);
        const titleElement = clonedBox.querySelector(
          ".product-bundle__selection-title"
        );
        if (titleElement) {
          titleElement.textContent = `${this.translations.option} ${this.translations[idx]}`;
        }
        parentContainer.appendChild(clonedBox);
      });

      this.productRemoveButtons = this.querySelectorAll(
        ".product-bundle__selection-remove"
      );
    }

    setupAddToPackAction() {
      this.productAddToPackButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          if (this.currentSelection === this.totalSelection) {
            return;
          }

          const target = event.target.closest(
            ".product-card--add-to-pack-button"
          );
          const productCard = target.closest("product-card");

          button.classList.add("active");

          const quantityWrapper = button.nextElementSibling;
          if (quantityWrapper?.classList.contains("quantity")) {
            const quantityInput = quantityWrapper.querySelector("input");
            const currentValue = parseInt(quantityInput.value, 10) || 0;
            quantityInput.value = currentValue + 1;
          }

          if (productCard) {
            const image = productCard.querySelector(".product-primary-image");
            const title = productCard.querySelector(
              ".product-card-title"
            )?.textContent;

            const selectionBox = this.querySelector(
              ".product-bundle__selection.is-empty"
            );

            if (selectionBox) {
              this.currentSelection += 1;
              const productId = target.dataset.productId;
              const variantId = target.dataset.variantId;
              const productTitle = target.dataset.productTitle;

              let sellingPlans = target.dataset.sellingPlans;
              if (sellingPlans) {
                sellingPlans = JSON.parse(sellingPlans);
              }

              // Check if the product already exists in selections
              const existingSelection = this.bundle.selections.find(
                (selection) => selection.externalProductId === productId
              );

              if (existingSelection) {
                // If it exists, increase the quantity
                existingSelection.quantity += 1;
              } else {
                // If it doesn't exist, add a new selection object
                this.bundle.selections.push({
                  collectionId: this.collectionId,
                  externalProductId: productId,
                  externalVariantId: variantId,
                  quantity: 1,
                  sellingPlan: sellingPlans,
                  title: productTitle,
                });
              }
              this.updateBagButton();

              if (this.currentSelection === this.totalSelection) {
                this.toggleQtyIncreaseButtons(false);
                this.toggleAddToCartButtons(false);
              }

              selectionBox.dataset.productId = productId;
              selectionBox.classList.remove("is-empty");
              const selectionBoxImage = selectionBox.querySelector(
                ".product-bundle__selection-image"
              );
              const selectionBoxTitle = selectionBox.querySelector(
                ".product-bundle__selection-title"
              );

              if (selectionBoxImage && image) {
                // Clone the image element to avoid removing it from the original location
                const clonedImage = image.cloneNode(true);
                // Append the cloned image
                selectionBoxImage.appendChild(clonedImage);
              }

              if (selectionBoxTitle && title) {
                selectionBoxTitle.textContent = title;
              }
            }
          }
        });
      });
    }

    setupQuantityActions() {
      this.productQuantityInputs.forEach((input) => {
        input.max = this.totalSelection;
      });

      this.productIncreaseQtyButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();

          if (button.disabled) {
            return;
          }

          const atcButton = this.getAddToCartButton(button);
          if (atcButton) {
            atcButton.click();

            if (this.currentSelection === this.totalSelection) {
              this.toggleQtyIncreaseButtons(false);
              this.toggleAddToCartButtons(false);
            }
          }
        });
      });

      this.productDecreaseQtyButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          const atcButton = this.getAddToCartButton(button);
          const productId = atcButton.dataset.productId;
          const activeProduct = this.getLastMatchingProduct(productId);

          this.handleProductRemoval(activeProduct);
        });
      });
    }

    toggleQtyIncreaseButtons(enable) {
      this.productIncreaseQtyButtons.forEach((button) => {
        button.disabled = !enable;
        button.classList.toggle("disabled", !enable);
      });
    }

    toggleAddToCartButtons(enable) {
      this.productAddToPackButtons.forEach((button) => {
        const isActive = button.classList.contains("active");
        const isOOS = button.classList.contains("oos");

        if (!isActive && (!enable || !isOOS)) {
          button.disabled = !enable;
          button.classList.toggle("disabled", !enable);
        }
      });
    }

    getAddToCartButton(button) {
      return button
        .closest(".product-card--add-to-cart-button-container")
        ?.querySelector("button");
    }

    getLastMatchingProduct(productId) {
      const matchingProducts = this.querySelectorAll(
        `.product-bundle__selection[data-product-id="${productId}"]`
      );
      return matchingProducts[matchingProducts.length - 1];
    }

    addBundleToCart() {
      if (this.bagButton.classList.contains('loading')) {
        return;
      }
      this.bagButton.classList.add('loading');
      // Subscriptions
      const subscriptionOptions = this.querySelector(
        ".selling_plan_app_container"
      );
      let sellingPlanId = null; // The parent's selling plan ID.

      if (subscriptionOptions) {
        const activePlan = subscriptionOptions.querySelector(
          "input[type='radio']:not([data-radio-type='subscription_purchase']):checked"
        );
        if (activePlan) {
          const sellingPlanName = activePlan.dataset.sellingPlanName;
          sellingPlanId = activePlan.dataset.sellingPlanId;

          if (sellingPlanName && sellingPlanId) {
            this.bundle.selections.forEach((selection) => {
              // Find the matching selling plan in the array
              const matchedPlan = selection.sellingPlan.find(
                (plan) => plan.name === sellingPlanName
              );

              // If a match is found, update `selection.sellingPlan` with just the ID
              if (matchedPlan) {
                selection.sellingPlan = matchedPlan.id;
              } else {
                delete selection.sellingPlan;
              }
            });
          } else {
            this.bundle.selections.forEach((selection) => {
              delete selection.sellingPlan;
            });
          }
        }
      }

      // This flag determines if we can redirect the page when these promsies resolve.
      let bundleAddedSuccessfully = false;

      recharge.bundle
        .validateBundle(this.bundle)
        .then(() => recharge.bundle.getBundleId(this.bundle))
        .then((bundleId) => {
          const bundleContents = this.bundle.selections
            .reduce((contents, item) => {
              if (item.quantity > 1) {
                contents.push(`${item.quantity}x ${item.title}`);
              } else {
                contents.push(item.title);
              }
              return contents;
            }, [])
            .join(", ");

          const formData = {
            items: [
              {
                id: this.bundle.externalVariantId,
                quantity: 1,
                properties: {
                  Scents: bundleContents,
                  _rb_id: bundleId,
                },
                selling_plan: sellingPlanId, // A value of 'null' is no selling plan.
              },
            ],
          };
          return fetch(`${theme.routes.cart_add_url}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          });
        })
        .then((response) => {
          bundleAddedSuccessfully = response.ok;

          if (bundleAddedSuccessfully && window.addedToCart) {
            // Track this add to cart event for Klaviyo.
            // We're not concerned with the success of this particular promise, because
            // a failed event tracking call should not block this user's journey.
            return addedToCart();
          }
        })
        .catch((error) => {
          this.bagButton.classList.remove('loading');
          console.error(error, this.bundle);
        })
        .finally(() => {
          if (bundleAddedSuccessfully) {
            window.location.assign(theme.routes.cart_url);
          }
        });
    }

    setupRemoveAction() {
      this.productRemoveButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          const selectionBox = event.target.closest(
            ".product-bundle__selection"
          );
          this.handleProductRemoval(selectionBox);
        });
      });
    }

    handleProductRemoval(selectionBox) {
      if (!selectionBox) {
        return;
      }

      const productId = selectionBox.dataset.productId;
      const index = this.bundle.selections.findIndex(
        (selection) => selection.externalProductId === productId
      );

      // Check if the product exists in selections
      if (index !== -1) {
        const selection = this.bundle.selections[index];

        if (selection.quantity > 1) {
          // If quantity is greater than 1, decrease the quantity
          selection.quantity -= 1;
        } else {
          // If quantity is 1, remove the item completely
          this.bundle.selections.splice(index, 1);
        }
      }

      const atcButton = this.querySelector(
        `.product-card--add-to-pack-button[data-product-id="${productId}"]`
      );
      const atcWrapper = atcButton.parentElement;
      const quantityInput = atcWrapper.querySelector("input");
      if (quantityInput) {
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        quantityInput.value = currentValue - 1;

        if (quantityInput.value === "0") {
          atcButton.classList.remove("active");
        }
      }

      selectionBox.dataset.productId = "";
      selectionBox.classList.add("is-empty");
      selectionBox.querySelector("img").remove();
      selectionBox.querySelector(
        ".product-bundle__selection-title"
      ).textContent =
        `${this.translations.option} ${this.translations[selectionBox.dataset.index]}`;
      this.currentSelection -= 1;
      this.updateBagButton();

      if (this.currentSelection < this.totalSelection) {
        this.toggleQtyIncreaseButtons(true);
        this.toggleAddToCartButtons(true);
      }
    }
  }

  customElements.define("product-bundle", ProductBundle);
}
